import { Download, ExternalLink, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { QrDynamicCard } from './QrDynamicCard';

const FILES = [
  { id: 'plain', title: 'QR clásico', desc: 'Módulos negros sobre blanco. Máxima lectura en impresión.', png: '/downloads/qr-estadia365.png', svg: '/downloads/qr-estadia365.svg' },
  { id: 'logo', title: 'QR con logo', desc: 'Con el ícono de Estadía 365 al centro. Para folletos premium.', png: '/downloads/qr-estadia365-logo.png', svg: '/downloads/qr-estadia365-logo.svg' },
];

function QrFileCard({ file }) {
  return (
    <div className="bg-white rounded-xl border border-[#E7E5E4] p-4 flex gap-4" data-testid={`qr-file-${file.id}`}>
      <img src={file.png} alt={file.title} className="w-28 h-28 rounded-lg border border-[#E7E5E4] bg-white shrink-0" />
      <div className="min-w-0 flex-1">
        <h3 className="font-semibold text-[#1C1917]">{file.title}</h3>
        <p className="text-xs text-[#78716C] mt-0.5 mb-3">{file.desc}</p>
        <div className="flex flex-wrap gap-2">
          <a href={file.png} download className="inline-flex" data-testid={`qr-download-png-${file.id}`}>
            <Button size="sm" className="bg-[#264639] hover:bg-[#1C352B]"><Download className="w-3.5 h-3.5 mr-1.5" /> PNG 2000px</Button>
          </a>
          <a href={file.svg} download className="inline-flex" data-testid={`qr-download-svg-${file.id}`}>
            <Button size="sm" variant="outline" className="border-[#E7E5E4]"><Download className="w-3.5 h-3.5 mr-1.5" /> SVG vectorial</Button>
          </a>
        </div>
      </div>
    </div>
  );
}

export function QrDownloads({ qrUrl }) {
  const copy = async () => {
    try { await navigator.clipboard.writeText(qrUrl); toast.success('Enlace copiado'); } catch { toast.error('No se pudo copiar'); }
  };
  return (
    <section className="mt-8" data-testid="qr-downloads">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <h2 className="text-lg font-semibold text-[#1C1917]" style={{ fontFamily: 'Outfit' }}>Archivos para imprimir</h2>
        <div className="flex items-center gap-2 text-sm">
          <code className="px-2 py-1 rounded bg-white border border-[#E7E5E4] text-[#264639]" data-testid="qr-url">{qrUrl}</code>
          <Button size="sm" variant="ghost" onClick={copy} data-testid="qr-copy-url-btn"><Copy className="w-4 h-4" /></Button>
          <a href="/qr" target="_blank" rel="noopener noreferrer" data-testid="qr-open-landing-link">
            <Button size="sm" variant="outline" className="border-[#E7E5E4]"><ExternalLink className="w-3.5 h-3.5 mr-1.5" /> Ver landing</Button>
          </a>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <QrDynamicCard />
        {FILES.map((f) => <QrFileCard key={f.id} file={f} />)}
      </div>
    </section>
  );
}
